import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('token-salud') || null,
    usuario: JSON.parse(localStorage.getItem('usuario')) || null,
    pacienteStore:null,
    personalStore:null
  },
  getters: {
    isAuthenticated: state => !!state.token,
    getUsuario: state => state.usuario,
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token-salud', token)
      } else {
        localStorage.removeItem('token-salud')
      }
    },
    SET_SESSION(state, { token, usuario }) {
      state.token = token
      state.usuario = usuario
    },
    setUsuario(state, usuario) {
      state.usuario = usuario
      if (usuario) {
        localStorage.setItem('usuario', JSON.stringify(usuario))
      } else {
        localStorage.removeItem('usuario')
      }
    },

    clearAuth(state) {
      state.token = null
      state.usuario = null
      localStorage.removeItem('token-salud')
      localStorage.removeItem('usuario')
    }
  },
  actions: {
    guardarToken({ commit }, token) {
      commit('setToken', token)
    },

    guardarUsuario({ commit }, usuario) {
      commit('setUsuario', usuario)
    },

    cerrarSesion({ commit }) {
      commit('clearAuth')
    },
    iniciarSesion({ commit }, { token, usuario }) {
      localStorage.setItem('token-salud', token)
      localStorage.setItem('usuario', JSON.stringify(usuario))
      commit('SET_SESSION', { token, usuario })
    },
  },
  modules: {
  }
})
